import React from 'react';
// import "./format4.css"

const Format4 = ({ modifyForm = {} }) => {
  const defaultColumns = [];

  const getVisibleColumns = (columns) => {
    let result = [];
    
    columns.forEach(col => {
      if (col.check) {
        result.push(col);
      }
    });
    
    return result;
  };

  // Get visible columns from lr_table
  const visibleColumns = getVisibleColumns(modifyForm?.lr_table || defaultColumns);

  // Get active copy from copies array
  const activeCopy = modifyForm?.copies?.find(copy => copy.check) || {
    name: "Original Copy",
    value: 1
  };

  // Calculate column widths dynamically
  const calculateColumnWidth = () => {
    const columnCount = visibleColumns.length;
    if (columnCount <= 3) return '120px';
    if (columnCount === 4) return '90px';
    return '70px';
  };

  // Extract data from modifyForm or use defaults
  const {
    name = "Format 4",
    address = "125-A, SCHEME NO.78, INDORE, Indore, 452001",
    item_desc = "Biscuits, Confectionary, Snacks",
    terms_conds = "Delivery Note should be given within the 30 Days of Delivery else we are liable to deduct due Freight. 2. Delayed Delivery will attract Damage, Haulting Charges as per the rules. 3. We will not be responsible for any Shortage if Truck is unloaded in Part Delivery in Tempo/Trucks."
  } = modifyForm;

  return (
    <>
    <style>
      {` body {
            margin: 0px;
        }

        table {
        border-bottom: 0px;
        }


        td.text-left.width_75.font14 {
            font-size: 12px;
            position: relative;

        }

        table.table_gray_bg {
            background: #efefef !important;
            margin: 0;
            font-size: 13px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc;
        }

        .table_gray_bg td {
            padding: 5px 15px !important;
        }

        .item_description {
            margin: 2px 0;
        }

        .address_new {
            margin: 0px;
            margin-bottom: 5px;
        }

        .Unloading_details td {
            line-height: 21px !important;
        }

        .height_div.paymentmode_height {
            height: 150px;
        }

        .height_div.paymentmode_height td {
            height: 20px !important;
        }

        .remarK-div {
            height: 34px;
        }

        td.remarK-div p {
            margin: 0;
            height: 60px;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(1) {
            width: 75px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(2) {
            width: 110px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(3) {
            width: 110px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(4) {
            width: 110px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(5) {
            width: 60px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(6) {
            width: 60px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(7) {
            width: 60px !important;
        }

        .gst_invoiceno_table .border_table tr td:nth-child(8) {
            width: 70px !important;
        }

        .graY-bg {
            background: #000 !important;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            color: white;
        }

        .overly_table thead td {
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
        }

        p.CONSIGNEE {
            margin: 0;
        }

        .gst_invoiceno_table td {
            height: 22px !important;
            border-top: 1px solid #efefef;
            line-height: 23px !important;
        }

        .height_div.gst_invoiceno_table theda tr td {
            border-bottom: 1px solid #ccc !important;
        }

        .gst_invoiceno_table .border_table tr.tfoot_bg td {
            line-height: 24px;
        }

        table.footer_table td {
            padding-left: 15px;
            padding-right: 15px;
        }

        table.footer_table {
            border-bottom: 1px solid #ccc;
        }

        .footer.margintop {
            margin-top: 60px !important;
        }

        .new_table td {
            line-height: 16px !important;
        }

        .poweredby {
            position: absolute;
            right: 0;
            font-size: 11px;
            margin-top: 3px;
            padding-right: 15px
        }

        .footer p {
            margin: 0
        }

        table.footer_table {
            position: relative
        }

        .footer {
            margin-top: 60px;
            font-weight: 700;
            padding-left: 15px;
            padding-right: 15px
        }

        td.Unloading_details .width_35 {
            font-weight: 400
        }

        table.routeDIv td {
            line-height: 22px;
            padding: 2px 15px
        }

        h2.payment_class {
            font-size: 15px;
            padding-left: 14px;
            margin-top: 5px;
            margin-bottom: 5px
        }

        td.bold_font {
            font-weight: 700
        }

    
        .invoice-box {
            padding: 3px;
            font-size: 12px;
            line-height: 16px;
            font-family: Roboto, sans-serif;
            color: #222;
            margin: 0 auto
        }

        .Remark {
            height: 1cm
        }

        span.orignal_copy {
            text-align: right;
            float: right;
            font-size: 11px;
            line-height: 17px
        }

        .border_b {
            border-bottom: 1px solid #ccc
        }

        table.p_comm td {
            padding: 2px 5px
        }

        table.p_comm {
            border-right: 1px solid #ccc
        }

        .width_30 {
            width: 15%
        }

        .text_center {
            text-align: center;
            display: block
        }

        .bold_text {
            font-weight: 700
        }

        .border_box {
            border: 1px solid #cccc
        }

        .p_0 {
            padding: 0 !important
        }

        span.poweredby {
            position: absolute;
            bottom: -20px;
            text-align: right;
            width: 100%;
            right: 4px;
            font-size: 9px
        }

        .Gst_in {
            font-weight: 900 !important;
            margin-top: 4px !important;
            margin-bottom: 0 !important
        }

        .Extra_p td {
            padding: 5px 15px !important
        }

        .address_outer p {
            margin: 0;
            margin-bottom: 5px
        }

        .Extra_p {
            border-top: 1px solid #ccc;
            position: relative
        }

        .border_r {
            border-right: 1px solid #ccc
        }

        .Signature_height {
            height: 1.63cm
        }

      
        .invoice-box table {
            width: 100%;
            line-height: inherit;
            text-align: left;
            border-collapse: collapse
        }

        .top_heading p {
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            margin-bottom: 10px
        }

        .height_div td {
            height: 18px
        }

        .top_heading_P {
            font-size: 22px !important;
            margin-bottom: 0 !important;
            margin-top: 0 !important;
            font-weight: 700 !important;
        }

        .left_table {
            border-right: 1px solid #ccc
        }

        .invoice-box table td {
            vertical-align: top;
            line-height: 20px
        }

        .text-left {
            text-align: left
        }

        .border_table thead td {
            font-weight: 700;
            padding: 6px 5px;
            font-size: 12px
        }

        .top_heading {
            padding: 10px 0 5px 15px
        }

        .invoice-box table tr.information table td {
            padding-bottom: 40px
        }

        .invoice-box table tr.heading td {
            background: #eee;
            border-bottom: 1px solid #ddd;
            font-weight: 700
        }

        .border_table td {
            padding: 8px 5px;
            height: 18px
        }

        tr.tfoot_bg td {
            line-height: 24px;
            border-top: 1px solid #ccc !important;
            border-bottom: 1px solid #ccc !important;
        }

        .overly_table td {
            height: 21px
        }

        .invoice-box table tr.details td {
            padding-bottom: 20px
        }

        .Heading_right {
            background: #efefef !important;
            margin: 0;
            padding: 4px 15px;
            font-size: 13px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc
        }

        @media print {
            .Heading_right {
                background: #efefef !important;
                -webkit-print-color-adjust: exact;
                border-top: 1px solid #ccc !important
            }
        }

        .invoice-box table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: 700
        }

        table.table_right thead td {
            padding: 0
        }

        .table_right td {
            padding: 3px 15px
        }

        .termsAndCondiotion {
            font-size: 12px;
            margin: 0;
            margin-bottom: 5px;
            margin-top: 5px
        }

        .b_0 {
            border-bottom: 0 !important;
            border-top: 0 !important
        }

        td.text-left.width_75 {
            text-align: right
        }

        .width_35 {
            width: 50%
        }

        .height_div {
            position: relative
        }

        td.Unloading_details {
            border-left: 1px solid #ccc;
            padding-top: 6px
        }

        tr.bg_darkGray {
            background: #444 !important;
            color: #fff
        }

        tr.bg_darkGray td {
            background: #444 !important;
            color: #fff
        }

        .overly_table {
            position: absolute;
            width: 100%;
            top: 0;
            border-bottom: 1px solid #ccc;
        }

        .border_table tr td:nth-child(1) {
            width: 80px;
            border-left: 0;
            padding-left: 15px
        }

        .border_table tr td:nth-child(2) {
            width: 50px
        }

        .border_table tr td:nth-child(3) {
            width: 150px
        }

        .border_table tr td:nth-child(4) {
            width: 130px
        }

        .border_table tr td:nth-child(5) {
            width: 76px;
            padding-right: 10px
        }

        .border_table tr td:nth-child(6) {
            width: 150px
        }

        .tfoot_bg td {
            padding: 0px 10px;
            background: #efefef !important;
            font-size: 12px;
            -webkit-print-color-adjust: exact
        }

        @media print {
            .tfoot_bg td {
                padding: 2px 10px;
                background: #efefef !important;
                font-size: 12px;
                -webkit-print-color-adjust: exact
            }
        }

        .address_bottom {
            margin: 0;
            height: 45px;
            line-height: 12px;
            padding-top: 0;
            margin-top: 0;
            font-size: 10px;
            padding-bottom: 4px
        }

        .address_bottom p {
            margin-bottom: 0
        }

        .m_b_10 {
            margin-bottom: 10px;
            margin-top: 10px
        }

        .oP_none {
            opacity: 0
        }

        .Address span {
            display: block;
            margin-bottom: 2px
        }

        .address_outer {
            height: 33px
        }

        .border_table.border_none td {
            border-color: #fff !important;
            line-height: 24px
        }

        .address_outer.address_box p {
            width: 500px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap
        }

        .top_heading_left {
            text-align: left !important;
        }

        .pagebreakafter {
            page-break-after: always;
        }


        .sheet.padding-2mm {
            padding: 2mm;
            background: white;
        }

        .sheet-content {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
        }
        @media (max-width: 319px) {
            .sheet-content{
            transform: scale(calc(20% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content{
            transform: scale(calc(20% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content{
            transform: scale(calc(20% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content{
            transform: scale(calc(22% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content{
            transform: scale(calc(24% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content{
            transform: scale(calc(26% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content{
            transform: scale(calc(26% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content{
            transform: scale(calc(28% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content{
            transform: scale(calc(28.6% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content{
            transform: scale(calc(30% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content{
            transform: scale(calc(30% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content{
            transform: scale(calc(30% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content{
            transform: scale(calc(33.6% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content{
            transform: scale(calc(35% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content{
            transform: scale(calc(36% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content{
            transform: scale(calc(37.5% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content{
            transform: scale(calc(38.6% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content{
            transform: scale(calc(42% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content{
            transform: scale(calc(44% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content{
            transform: scale(calc(46% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content{
            transform: scale(calc(48% * 2 )) !important;
            transform-origin: 5px 0px;
        }
        }

        @media (max-width: 767px) {
            .sheet-content {
                margin: 0 auto;
            }
        }`}
    </style>

    <div className="A5 landscape">
      <div className="sheet-content">
        <section className="sheet padding-2mm">
          <div id="printableArea221">
            <table style={{ pageBreakAfter: 'always', width: '100%' }} cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td>
                    <div className="invoice-box">
                      <h3
                        style={{
                          fontSize: '10px',
                          textAlign: 'left',
                          fontFamily: 'Roboto,sans-serif',
                          textTransform: 'uppercase',
                          marginBottom: '0px',
                          marginTop: '0px',
                        }}
                      ></h3>
                      <div className="border_box">
                        <table cellPadding="0" cellSpacing="0">
                          <tbody>
                            <tr className="top">
                              <td>
                                <table cellPadding="0" cellSpacing="0">
                                  <tbody>
                                    <tr>
                                      <td style={{ width: '60%' }} className="left_table">
                                        <table cellPadding="0" cellSpacing="0">
                                          <thead>
                                            <tr>
                                              <th colSpan="2" className="top_heading_left">
                                                <div className="top_heading">
                                                  <p className="top_heading_P">{address}</p>
                                                  <p className="Address">
                                                    <span>{address}</span>
                                                    <span>sakshicarriers@gmail.com, +91 9200031247</span>
                                                  </p>
                                                  <p className="Gst_in">GST NO. 23ADGFS8194L2ZF</p>
                                                </div>
                                              </th>
                                            </tr>
                                          </thead>
                                        </table>
                                      </td>
                                      <td style={{ width: '40%' }}>
                                        <table className="table_right new_table" cellPadding="0" cellSpacing="0">
                                          <thead>
                                            <tr>
                                              <td colSpan="2">
                                                <table className="table_gray_bg">
                                                  <tbody>
                                                    <tr>
                                                      <td className="bold_text width_35">L.R.COPY</td>
                                                      <td className="text-left width_75 font14">
                                                        <span>({activeCopy.name})</span>
                                                        <span className="number">({activeCopy.value})</span>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td className="bold_text width_35">Trip No.</td>
                                              <td className="text-left width_75">6026</td>
                                            </tr>
                                            <tr>
                                              <td className="bold_text width_35">Vehicle No.</td>
                                              <td className="text-left width_75">MH40BG4590</td>
                                            </tr>
                                            <tr>
                                              <td className="bold_text width_35">Date</td>
                                              <td className="text-left width_75">25/05/2024</td>
                                            </tr>
                                            <tr>
                                              <td className="bold_text width_35">MLR No.</td>
                                              <td className="text-left width_75">12345</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ borderTop: '1px solid #ccc' }}>
                                <table width="100%;" cellPadding="0" cellSpacing="0">
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          width: '50%',
                                          borderRight: '1px solid #ccc',
                                          paddingTop: '3px',
                                          paddingBottom: '3px',
                                          paddingRight: '0px',
                                        }}
                                      >
                                        <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                                          <tbody>
                                            <tr>
                                              <td colSpan="1" style={{ paddingLeft: '15px' }}>
                                                <p style={{ margin: '0px' }}>
                                                  <strong>CONSIGNER-</strong>
                                                  Parle Biscuites Pvt. Ltd.
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colSpan="1" style={{ height: '40px', paddingLeft: '15px' }}>
                                                <p style={{ marginBottom: '0px', marginTop: '0px' }}>
                                                  <strong>C/O- Market Loading Transportation</strong>
                                                </p>
                                                <p className="address_new">
                                                  125 sector A scheme no. 78, indore- 452015
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style={{ paddingLeft: '15px' }}>
                                                <p style={{ marginBottom: '5px', marginTop: '0px' }}>
                                                  <strong>GSTIN-</strong>
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style={{ paddingLeft: '15px', borderTop: '1px solid #ccc' }}>
                                                <p className="item_description">
                                                  <strong>Item Description-</strong>
                                                  {item_desc}
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                      <td
                                        style={{
                                          width: '50%',
                                          paddingTop: '3px',
                                          paddingLeft: '8px',
                                          paddingBottom: '3px',
                                          paddingRight: '15px',
                                        }}
                                      >
                                        <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                                          <tbody>
                                            <tr>
                                              <td colSpan="1">
                                                <table>
                                                  <tbody>
                                                    <tr>
                                                      <td style={{ width: '15%' }}>
                                                        <strong>CONSIGNEE-</strong>
                                                      </td>
                                                      <td colSpan="3">
                                                        <span style={{ width: '85%', fontWeight: 'bold' }}></span>
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td style={{ width: '15%', paddingBottom: '10px' }}>
                                                        <strong>ADDRESS-</strong>
                                                      </td>
                                                      <td
                                                        colSpan="3"
                                                        style={{
                                                          paddingBottom: '10px',
                                                          width: '85%',
                                                          height: '44px',
                                                        }}
                                                      >
                                                        <span>, ,</span>
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td style={{ width: '15%' }}>
                                                        <strong>CONTACT-</strong>
                                                      </td>
                                                      <td colSpan="3" style={{ width: '85%' }}>
                                                        <span></span>
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td style={{ width: '15%' }}>
                                                        <strong>GSTIN-</strong>
                                                      </td>
                                                      <td>
                                                        <span></span>
                                                      </td>
                                                      <td style={{ width: '13%', textAlign: 'right' }}>
                                                        <strong>CODE-</strong>
                                                      </td>
                                                      <td style={{ textAlign: 'left' }}>
                                                        <span style={{ marginLeft: '40px' }}></span>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="height_div gst_invoiceno_table">
                                  <table
                                    cellPadding="0"
                                    cellSpacing="0"
                                    className="border_table border_none"
                                  >
                                    <thead>
                                      <tr>
                                        {visibleColumns.map((column, index) => (
                                          <td key={index} className="graY-bg">
                                            {column.name}
                                          </td>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody style={{ width: '50%', borderBottom: '1px solid #ccc' }}>
                                      <tr>
                                        {visibleColumns.map((column, index) => (
                                          <td key={index}>-</td>
                                        ))}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table cellPadding="0" cellSpacing="0" className="holding_table">
                                  <tbody>
                                    <tr>
                                      <td style={{ width: '50%', borderBottom: '1px solid #ccc' }}>
                                        <p
                                          style={{
                                            fontWeight: 'bold',
                                            paddingLeft: '15px',
                                            paddingRight: '10px',
                                            marginTop: '5px',
                                            lineHeight: '15px',
                                            fontSize: '10px',
                                          }}
                                        >
                                          <strong>Remark:</strong>
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table cellPadding="0" cellSpacing="0" className="holding_table">
                                  <tbody>
                                    <tr>
                                      <td style={{ width: '50%', borderRight: '1px solid #ccc' }}>
                                        <p
                                          style={{
                                            fontWeight: 'bold',
                                            paddingLeft: '15px',
                                            paddingRight: '10px',
                                            marginTop: '5px',
                                            lineHeight: '15px',
                                            fontSize: '10px',
                                          }}
                                        >
                                          <strong>Terms &amp; Conditions:</strong> {` ${modifyForm?.terms_conds}`}
                                        </p>
                                      </td>
                                      <td style={{ width: '50%' }}>
                                        <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                                          <tbody>
                                            <tr>
                                              <td style={{ width: '50%' }}>
                                                <div className="footer margintop" style={{ textAlign: 'left' }}>
                                                  <p style={{ color: '#707070', fontWeight: '400' }}>Driver</p>
                                                </div>
                                              </td>
                                              <td style={{ width: '50%' }}>
                                                <div className="footer margintop" style={{ textAlign: 'right' }}>
                                                  <p style={{ color: '#707070', fontWeight: '400' }}>
                                                    Authorized Signature
                                                  </p>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
    </>
  );
};

export default Format4;